/* eslint-disable max-classes-per-file */
// https://sondermind-jira.atlassian.net/browse/PE-27267

import {
  Directive, HostBinding, Input
} from '@angular/core';

import { BreakpointsService } from '@sondermind/utilities/services';

export type ThemeName = 'light' | 'dark' | 'primary' | 'accent' | 'success' | 'warning' | 'error' | 'disabled';
export type EffectName = 'faded' | 'strong';
export type TypeName = 'hero' | 'badge' | 'link' | 'legal';
export type AlignName = 'left' | 'right' | 'center';
export type WidthName = 'auto' | 'full';
export type OverflowName = 'ellipsis' | 'hidden';

// generic typography styles (theme, etc)

@Directive({
  selector: '[sondermind-type]',
  standalone: false
})
export class TypographyMixinDirective {
  constructor(
    private breakpoints: BreakpointsService
  ) {}

  @Input()
    theme: ThemeName;

  @Input()
    styleError = false;

  @HostBinding('attr.data-theme')
  get styleTheme() {
    if (this.styleError) {
      return 'error';
    }

    return this.theme;
  }

  @Input()
  @HostBinding('attr.data-type')
    type: TypeName;

  @Input()
  @HostBinding('attr.data-align')
    align: AlignName;

  @Input()
  @HostBinding('attr.data-float')
    float: 'left' | 'right';

  @Input()
  @HostBinding('attr.data-width')
    width: WidthName;

  @HostBinding('attr.data-mobile')
  get mediaQuery() {
    return this.breakpoints.isMobile;
  }

  @Input()
  @HostBinding('attr.data-effect')
    effect: EffectName;

  @Input()
  @HostBinding('attr.data-overflow')
    overflow: OverflowName;

  @Input()
  @HostBinding('class.sondermind-typography')
    isType = true;
}

@Directive({
  selector: 'br[separator]',
  standalone: false
})
export class SeparatorDirective {
  @HostBinding('attr.data-separator')
    isSep = true;
}

// allow icons to have badges
@Directive({
  selector: 'mat-icon[sondermindBadge]',
  standalone: false
})
export class MatIconBadgeDirective {
  @HostBinding('attr.data-badged')
  @Input()
    sondermindBadge = false;
}

// fix styles for mat-icon inline

@Directive({
  selector: 'mat-icon[inline="true"]:not([data-nofix]),mat-icon[inline=""]:not([data-nofix])',
  standalone: false
})
export class MatIconInlineOverrideDirective {
  @HostBinding('attr.data-inline-fix')
    myFix = true;
}

export const Declarations = [
  MatIconInlineOverrideDirective,
  MatIconBadgeDirective,
  TypographyMixinDirective,
  SeparatorDirective
];
